import { CreatePasswordScreen } from "@/interactors/CreatePasswordScreen";

export default function AuthedCreatePasswordRoute() {
  return <CreatePasswordScreen />;
}
